import { useCallback, useState, ChangeEventHandler } from 'react';

export interface CheckedProps {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

type ReturnedCheckedProps = Omit<CheckedProps, 'defaultChecked'>;

export const useChecked = ({
  checked,
  defaultChecked = false,
  onChange,
}: CheckedProps): ReturnedCheckedProps => {
  const [checkedState, setCheckedState] = useState(defaultChecked);

  const handleChange = useCallback(
    (evt: any) => {
      setCheckedState(evt.target.checked);
      if (onChange) onChange(evt);
    },
    [onChange]
  );

  return {
    checked: checked !== undefined ? checked : checkedState,
    onChange: handleChange,
  };
};
